(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kaya-service-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kaya-service-menu')) {
  customElements.define('kaya-service-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal:this.controller.signal };
      const button = this.querySelector('button');
      const panel = this.querySelector('[popover]');
      if (!button || !panel) return;
      panel.addEventListener('beforetoggle', event => {
        if (event.newState !== 'open') return;
        const rect = button.getBoundingClientRect();
        const header = this.closest('header-component')?.getBoundingClientRect();
        const overflow = this.closest('[slot="overflow"]');
        const top = Math.min(overflow ? rect.bottom : Math.max(rect.bottom, header?.bottom || 0), innerHeight - 64);
        const width = Math.min(310, innerWidth - 24);
        panel.style.left = `${Math.max(12, Math.min(rect.left, innerWidth - width - 12))}px`;
        panel.style.top = `${Math.max(12, top)}px`;
        panel.style.maxHeight = `${innerHeight - Math.max(12, top) - 12}px`;
      }, options);
      panel.addEventListener('toggle', event => button.setAttribute('aria-expanded', String(event.newState === 'open')), options);
      const close = () => { if (panel.matches(':popover-open')) panel.hidePopover(); };
      window.addEventListener('resize', close, options);
      window.addEventListener('scroll', event => { if (!panel.contains(event.target)) close(); }, { ...options, capture:true, passive:true });
      this.addEventListener('focusout', event => { if (event.relatedTarget && !this.contains(event.relatedTarget)) close(); }, options);
      panel.addEventListener('click', event => { if (event.target.closest('a')) close(); }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
